export enum DocumentNodeType {
    Document = 'DOCUMENT',
    Folder = 'FOLDER',
}

export enum DocumentType {
    Access = 'ACCESS',
    Exact = 'EXACT',
    Excel = 'EXCEL',
    ExcelCsv = 'EXCEL_CSV',
    ExcelTpl = 'EXCEL_TPL',
    Infopath = 'INFOPATH',
    Mollie = 'MOLLIE',
    OneNote = 'ONENOTE',
    OneNoteToc = 'ONENOTE_TOC',
    Outlook = 'OUTLOOK',
    PDF = 'PDF',
    PowerPoint = 'POWERPOINT',
    PowerPointSs = 'POWERPOINT_SS',
    PowerPointTpl = 'POWERPOINT_TLP',
    Project = 'PROJECT',
    ProjectTpl = 'PROJECT_TPL',
    Publisher = 'PUBLISHER',
    Reader = 'READER',
    TeamViewer = 'TEAMVIEWER',
    Twinfield = 'TWINFIELD',
    Visio = 'VISIO',
    VisioStencil = 'VISIO_STENCIL',
    VisioTpl = 'VISIO_TPL',
    Word = 'WORD',
    WordBackup = 'WORD_BACKUP',
    WordTpl = 'WORD_TPL',
    Folder = 'FOLDER',
    FolderClosed = 'FOLDER_CLOSED',
    Other = 'OTHER',
}

export interface IDocumentStackItemDto {
    id: string
    name: string
}

// Do not use this one, because it's only an intermediate format.
export interface IOverviewItemDto {
    id: string
    type: DocumentNodeType
    name: string
    url: string
    webUrl: string
    webDavUrl: string
    parentId: string
    stack: IDocumentStackItemDto[]
}

export interface IFolderOverviewItemDto extends IOverviewItemDto {
    children?: DocumentOverviewItemDto[]
}

export type IRootOverviewItemDto = IFolderOverviewItemDto

export interface IDocumentOverviewItemDto extends IOverviewItemDto {
    date: string
}

export type DocumentOverviewItemDto = IFolderOverviewItemDto | IDocumentOverviewItemDto

export interface IDefaultFolderDto {
    type?: FolderType
    label: string
    order: number
    excluded?: boolean
}

export const isFolder = (item: DocumentOverviewItemDto): item is IFolderOverviewItemDto => item.type === DocumentNodeType.Folder

export const isDocument = (item: DocumentOverviewItemDto): item is IDocumentOverviewItemDto => item.type === DocumentNodeType.Document

export enum DocumentContext {
    Document = 'DOCUMENT',
    Party = 'PARTY',
}

export enum DocumentIconSource {
    Office = 'OFFICE', // The icon exists as file type Office UI.
    Svg = 'SVG', // A custom SVG exists
    Icon = 'ICON', // The icon exists as icon in Office UI.
    Image = 'IMAGE', // The icon exists as icon in Office UI.
}

export enum DocumentSortOrder {
    NameAsc = 'NameAsc',
    NameDesc = 'NameDesc',
    ModifiedAsc = 'ModifiedAsc',
    ModifiedDesc = 'ModifiedDesc',
}

export const DocumentIconSourceMap: Map<DocumentType | string, DocumentIconSource> = new Map([
    [DocumentType.Exact, DocumentIconSource.Image],
    [DocumentType.Mollie, DocumentIconSource.Image],
    [DocumentType.Outlook, DocumentIconSource.Svg],
    [DocumentType.Reader, DocumentIconSource.Svg],
    [DocumentType.TeamViewer, DocumentIconSource.Svg],
    [DocumentType.Twinfield, DocumentIconSource.Svg],
    [DocumentType.Folder, DocumentIconSource.Icon],
    [DocumentType.FolderClosed, DocumentIconSource.Icon],
])

// Used for creating new documents.
export const DocumentIconNameMap: Map<DocumentType, string> = new Map([
    [DocumentType.Word, 'docx'],
    [DocumentType.WordBackup, 'docx'],
    [DocumentType.WordTpl, 'dotx'],
    [DocumentType.Exact, 'exact.ico'],
    [DocumentType.Excel, 'xlsx'],
    [DocumentType.ExcelTpl, 'xltx'],
    [DocumentType.Mollie, 'mollie.ico'],
    [DocumentType.Outlook, 'outlook'],
    [DocumentType.PDF, 'pdf'],
    [DocumentType.PowerPoint, 'pptx'],
    [DocumentType.Reader, 'reader'],
    [DocumentType.TeamViewer, 'teamviewer'],
    [DocumentType.Twinfield, 'twinfield'],
    [DocumentType.Folder, 'OpenFolderHorizontal'],
    [DocumentType.FolderClosed, 'FolderHorizontal'],
])

export enum FolderType {
    // noinspection JSUnusedGlobalSymbols
    Email = 'EMAIL',
    Attachments = 'ATTACHMENTS',
    Correspondence = 'CORRESPONDENCE',
    Finance = 'FINANCE',
    Other = 'OTHER',
}
